module.exports = __webpack_public_path__ + "img/cx.18a45791.svg";